module.exports = __webpack_public_path__ + "img/disconnected.cbc3317c.png";